module.exports = __webpack_public_path__ + "static/media/render-rear-view.d50e448e.png";